__turbopack_context__.v({
  "breadcrumbsWrp": "styles-module__Vad8lG__breadcrumbsWrp",
  "contactsCards": "styles-module__Vad8lG__contactsCards",
  "contactsMainbanner": "styles-module__Vad8lG__contactsMainbanner",
  "contactsPage": "styles-module__Vad8lG__contactsPage",
  "formField": "styles-module__Vad8lG__formField",
  "formWrapper": "styles-module__Vad8lG__formWrapper",
  "mainWrap": "styles-module__Vad8lG__mainWrap",
  "policyWrapper": "styles-module__Vad8lG__policyWrapper",
});
